import { render, staticRenderFns } from "./Korisnici.vue?vue&type=template&id=6af245dd&scoped=true&"
import script from "./Korisnici.vue?vue&type=script&lang=js&"
export * from "./Korisnici.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af245dd",
  null
  
)

export default component.exports